import { StateService } from '@infra/state/state.service';
import { AsyncPipe } from '@angular/common';
import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { NotificationDTO } from '@api/models';
import { NotificationService } from '@api/services/notification.service';
import { TranslatePipe } from '@ngx-translate/core';
import { AvatarByIdPipe } from '@shared/pipes/avatar-by-id.pipe';
import { UserByIdPipe } from '@shared/pipes/user-by-id.pipe';
import { AvatarComponent } from '@common/ui/avatar/avatar.component';
import { Globals } from '@system/globals';

@Component({
  selector: 'app-agent-notification',
  templateUrl: './notification.component.html',
  imports: [TranslatePipe, AvatarComponent, AvatarByIdPipe, UserByIdPipe, AsyncPipe],
})
export class AgentNotificationComponent {
  private readonly notificationService = inject(NotificationService);
  private readonly stateService = inject(StateService);

  @Input() notification: NotificationDTO;
  @Input() totalUnreadNotificationCount: number;
  @Output() opened = new EventEmitter<void>();

  globals = Globals;

  markNotification(notification: NotificationDTO): void {
    if (notification.readDateTime !== null) {
      this.notificationService.unread(notification.id).subscribe(() => {
        this.stateService.setUnreadNotificationCount(this.totalUnreadNotificationCount + 1);
        notification.readDateTime = null;
      });
    } else if (notification.readDateTime === null) {
      this.notificationService.read(notification.id).subscribe(() => {
        this.stateService.setUnreadNotificationCount(this.totalUnreadNotificationCount - 1);
        notification.readDateTime = new Date();
      });
    }
  }

  openNotification(notification: NotificationDTO, openInNewTab: boolean): void {
    if (notification.readDateTime === null) {
      this.stateService.setUnreadNotificationCount(this.totalUnreadNotificationCount - 1);
    }

    this.opened.emit();

    this.notificationService.openNotification(notification, openInNewTab).subscribe();
  }
}
